import { render, staticRenderFns } from "./TestimonialOverviewPopUp.vue?vue&type=template&id=34ff515e&scoped=true&"
import script from "./TestimonialOverviewPopUp.vue?vue&type=script&lang=js&"
export * from "./TestimonialOverviewPopUp.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialOverviewPopUp.vue?vue&type=style&index=0&id=34ff515e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ff515e",
  null
  
)

export default component.exports